import React from 'react'

export const IconChevronRight = props => {
  return (
    <svg viewBox="0 0 11 18" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="m0 15.9 6.9-6.9-6.9-7 2-2 9 9-9 8.9z" fill-rule="evenodd" />
    </svg>
  )
}
